import { observable, action, computed } from 'mobx';
import { ReqInputMsg, Addition, callCmd } from 'lib/reqInputMsg';
import { notification } from 'antd';

export default class GoodsGroupStore {
  constructor(root) {
    this.root = root;
  }

  //----------------------------------
  /* Mainstore에서 세션만료 처리하기위해 */
  @observable
  _commonStoreInfo = null;

  @computed
  get commonStoreInfo() {
    return this._commonStoreInfo;
  }

  @action
  setCommonStoreInfo = (storeInfo) => {
    this._commonStoreInfo = storeInfo;
  };
  //----------------------------------
  /* 화면 변경 목록, 상세보기, 수정, 추가 */
  @observable
  _viewMode = 'list';

  @computed
  get viewMode() {
    return this._viewMode;
  }

  @action
  onViewMode = (mode) => {
    // list, detail, add
    this._viewMode = mode;
    if (mode === 'add') {
      this._detailData = null;
    }
  };
  //----------------------------------
  /* 검색조건 */
  @observable 
  _valCondition = {
    groupNm: '',
    useYn: '',

    pageIdx: 1,
    recordCountPerPage: 10,
  };

  @computed
  get valCondition() {
    return this._valCondition;
  }

  @action
  onChangValue = (dataNm, dataVal) => {
    this._valCondition = {
      ...this._valCondition,
      [dataNm]: dataVal
    };
  };
  //----------------------------------
  /* 상세데이터 */
  @observable
  _detailData = null;

  @computed
  get detailData() {
    return this._detailData;
  }

  @action
  onDetailData = (data) => {
    this._detailData = data;
  };
  //----------------------------------
  @observable 
  _goodsGroupList = [];

  @computed
  get goodsGroupList() {
    return this._goodsGroupList;
  }

  @observable
  _pageInfo = null;

  @computed
  get pageInfo() {
    return this._pageInfo;
  }
  //----------------------------------
  @action
  onClear = () => {
    this._viewMode = 'list';

    this._goodsGroupList = [];
    this._pageInfo = null;
    this._detailData = null;
    this._valCondition = {
      groupNm: '',
      useYn: '',

      pageIdx: 1,
      recordCountPerPage: 10,
    };
  };

  //-----------------------------------------------------------------------//
  @action
  disGoodsGroupList = async (pageIdx, recordCountPerPage) => {
    if (pageIdx !== undefined && pageIdx !== null && this._valCondition.pageIdx !== pageIdx) {
      this._valCondition.pageIdx = pageIdx;
    }
    if (recordCountPerPage !== undefined && recordCountPerPage !== null && this._valCondition.recordCountPerPage !== recordCountPerPage) {
      this._valCondition.recordCountPerPage = recordCountPerPage;
    }

    let addition = new Addition();
    addition.setCmdName('DIS-GOODSGROUP-LIST');
    addition.setPageYn('Y');
    addition.setPageIndex(this._valCondition.pageIdx);
    addition.setRecordCountPerPage(this._valCondition.recordCountPerPage);
    
    var reqInputMsg = new ReqInputMsg();
    reqInputMsg.setAddition(addition);
    reqInputMsg.addParam({paraName: 'groupNm', paraValue: this._valCondition.groupNm});
    reqInputMsg.addParam({paraName: 'useYn', paraValue: this._valCondition.useYn});
    
    return await callCmd(reqInputMsg, 'goodsInfo')
      .then((res) => {
        if (res.error.code === '0000') {
          this._goodsGroupList = res.result;
          this._pageInfo = res.addition;
        } else if (res.error.code === '0003') {
          if (this._commonStoreInfo !== null) {
            this._commonStoreInfo.onSessionOut();
          }
        } else {
          notification.error({placement: 'bottomLeft', message:`리스트를 불러오는데 실패하였습니다.`, duration: 2, description: `${res.error.code}`});
          this._goodsGroupList = [];
          this._pageInfo = null;
        }
      }).catch((error) => {
        notification.error({placement: 'bottomLeft', message:`조회가 실패하였습니다.`, duration: 2, description: `서버 연결을 확인하세요.`});
        this._goodsGroupList = [];
        this._pageInfo = null;
        console.log('error', error);
      });
  };

  @action
  disGoodsGroupDetail = async (data) => {
    let addition = new Addition();
    addition.setCmdName('DIS-GOODSGROUP-DETAIL');
    
    var reqInputMsg = new ReqInputMsg();
    reqInputMsg.setAddition(addition);
    reqInputMsg.addParam({paraName: 'groupCd', paraValue: data.groupCd});
    
    return await callCmd(reqInputMsg, 'goodsInfo')
      .then((res) => {
        if (res.error.code === '0000') {
            this._viewMode = 'detail';
            this._detailData = {
              ...data,
              gdCdList: res.result
            };
        } else if (res.error.code === '0003') {
          if (this._commonStoreInfo !== null) {
            this._commonStoreInfo.onSessionOut();
          }
        } else {
          notification.error({placement: 'bottomLeft', message:`상세정보를 불러오는데 실패하였습니다.`, duration: 2, description: `${res.error.code}`});
          this._detailData = null;
        }
      }).catch((error) => {
        notification.error({placement: 'bottomLeft', message:`조회가 실패하였습니다.`, duration: 2, description: `서버 연결을 확인하세요.`});
        this._detailData = null;
        console.log('error', error);
      });
  };

  @action
  merGoodsGroupList = async (data) => {
    let addition = new Addition();
    addition.setCmdName('MER-GOODSGROUP-LIST');

    var reqInputMsg = new ReqInputMsg();
    reqInputMsg.setAddition(addition);
    reqInputMsg.addParam({paraName: 'groupCd', paraValue: data.groupCd === '' ? null : data.groupCd});
    reqInputMsg.addParam({paraName: 'groupNm', paraValue: data.groupNm});
    reqInputMsg.addParam({paraName: 'groupOrder', paraValue: data.groupOrder});
    reqInputMsg.addParam({paraName: 'useYn', paraValue: data.useYn});
    reqInputMsg.addParam({paraName: 'gdCdList', paraValue: data.gdCdList});

    return await callCmd(reqInputMsg, 'goodsInfo')
      .then((res) => {
        if (res.error.code === '0000') {
          if (res.result[0].resultMsg) {
            notification.success({placement: 'bottomLeft', message:`등록이 성공하였습니다.`, duration: 2});
            this._viewMode = 'list';
            this.disGoodsGroupList();
          } else {
            notification.success({placement: 'bottomLeft', message:`등록이 실패하였습니다.`, duration: 2});
          }
        } else if (res.error.code === '0003') {
          if (this._commonStoreInfo !== null) {
            this._commonStoreInfo.onSessionOut();
          }
        } else {
          notification.success({placement: 'bottomLeft', message:`등록이 실패하였습니다.`, duration: 2, description: `${res.error.code}`});
        }
      }).catch((error) => {
        notification.error({placement: 'bottomLeft', message:`등록이 실패하였습니다.`, duration: 2, description: `서버 연결을 확인하세요.`});
        console.log('error', error);
      });
  };

  @action
  delGoodsGroupList = async (data) => {
    let addition = new Addition();
    addition.setCmdName('DEL-GOODSGROUP-LIST');

    var reqInputMsg = new ReqInputMsg();
    reqInputMsg.setAddition(addition);
    reqInputMsg.addParam({paraName: 'groupCd', paraValue: data.groupCd});
    reqInputMsg.addParam({paraName: 'groupNm', paraValue: data.groupNm});
    reqInputMsg.addParam({paraName: 'gdCdList', paraValue: data.gdCdList});
    
    return await callCmd(reqInputMsg, 'goodsInfo')
      .then((res) => {
        if (res.error.code === '0000') {
          if (res.result[0].resultMsg) {
            notification.success({placement: 'bottomLeft', message:`수정이 성공하였습니다.`, duration: 2});
            this._viewMode = 'list';
            this.disGoodsGroupList();
          } else {
            notification.success({placement: 'bottomLeft', message:`수정이 실패하였습니다.`, duration: 2});
          }
        } else if (res.error.code === '0003') {
          if (this._commonStoreInfo !== null) {
            this._commonStoreInfo.onSessionOut();
          }
        } else {
          notification.success({placement: 'bottomLeft', message:`수정이 실패하였습니다.`, duration: 2, description: `${res.error.code}`});
        }
      }).catch((error) => {
        notification.error({placement: 'bottomLeft', message:`수정이 실패하였습니다.`, duration: 2, description: `서버 연결을 확인하세요.`});
        console.log('error', error);
      });
  };

  @action
  goodsGroupUserYn = async (groupCd, useYn) => {
    let addition = new Addition();
    addition.setCmdName('GOODSGROUP-USE-YN');

    var reqInputMsg = new ReqInputMsg();
    reqInputMsg.setAddition(addition);
    reqInputMsg.addParam({paraName: 'groupCd', paraValue: groupCd});
    reqInputMsg.addParam({paraName: 'useYn', paraValue: useYn === 'Y' ? 'N' : 'Y'});

    return await callCmd(reqInputMsg, 'goodsInfo')
      .then((res) => {
        if (res.error.code === '0000') {
          if (res.result[0].resultMsg) {
            notification.success({placement: 'bottomLeft', message:`수정에 성공하였습니다.`, duration: 2});
            this.disGoodsGroupList();
          } else {
            notification.success({placement: 'bottomLeft', message:`수정에 실패하였습니다.`, duration: 2});
          }
        } else if (res.error.code === '0003') {
          if (this._commonStoreInfo !== null) {
            this._commonStoreInfo.onSessionOut();
          }
        } else {
          notification.success({placement: 'bottomLeft', message:`수정에 실패하였습니다.`, duration: 2, description: `${res.error.code}`});
        }
      }).catch((error) => {
        notification.error({placement: 'bottomLeft', message:`수정에 실패하였습니다.`, duration: 2, description: `서버 연결을 확인하세요.`});
        console.log('error', error);
      });
  };
}
  
